module.exports = __webpack_public_path__ + "img/highlights4.50f39bc5.png";